/**
 * PLUGIN-KERNEL — the app-owned filter the activity plugin reads.
 *
 * The shift filter narrows the SQL the local feed runs, so it cannot live
 * inside the page: the data source is mounted by the kernel, above the route.
 * It lives here, as a small signal the page writes and the composition reads.
 *
 * Everything POS-specific about the activity feed is in this file and in
 * `ActivityFeedFilter` (packages/shared/src/activity/queries.ts). The plugin
 * itself knows nothing about register sessions.
 */
import { createSignal } from "solid-js";
import type { ActivityRow, ActivityFeedFilter } from "@comandero/shared";

export const ALL_SESSIONS = "__all__";

const [shiftSessionId, setShiftSessionId] = createSignal<string | undefined>(undefined);

export { shiftSessionId };

/** `ALL_SESSIONS` (or `undefined`) means "no narrowing". */
export function setShiftSession(value: string | undefined | null): void {
  setShiftSessionId(!value || value === ALL_SESSIONS ? undefined : value);
}

/** Reactive filter handed to the activity plugin through the composition. */
export function activityFilter(): ActivityFeedFilter {
  return { registerSessionId: shiftSessionId() };
}

/**
 * Keeps deep-history pages consistent with the active shift: a page fetched
 * under a previous filter is still in memory and must not leak into the
 * narrowed view.
 */
export function activityRowMatches(row: ActivityRow, filter: ActivityFeedFilter): boolean {
  return !filter.registerSessionId || row.register_session_id === filter.registerSessionId;
}
